export enum InstrumentType {
    EQUITY = "EQUITY",
    FUTURE = "FUTURE",
    BOND = "BOND"
}